import { createFileRoute } from "@tanstack/react-router";
import RaporteazaListare from "@/pages/incredere/RaporteazaListare";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/incredere/raporteaza-listare/")({
  head: () => routeHead("/incredere/raporteaza-listare/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <RaporteazaListare />
  );
}
